import { DominoBuilderError, DominoBuilderErrorScope, DominoBuilderErrorSeverity, DominoBuilderErrorType, } from '../../errors';
import { t } from '../../translate';
export function validateInputs(value) {
    return value.map((param, paramIdx) => {
        const errors = [];
        if (param === null || !!!param.name) {
            errors.push(new DominoBuilderError(DominoBuilderErrorType.MissingNameWarning, DominoBuilderErrorScope.DESIGN, DominoBuilderErrorSeverity.ERROR, t('errors.trigger_variables.name_required'), {
                path: `TriggerVariable::${JSON.stringify(param)}`,
            }));
        }
        else if (value.filter((val, valIdx) => val !== null && valIdx < paramIdx && val.name === param.name).length > 0) {
            errors.push(new DominoBuilderError(DominoBuilderErrorType.TypeError, DominoBuilderErrorScope.DESIGN, DominoBuilderErrorSeverity.ERROR, t('errors.trigger_variables.name_clash'), {
                path: `TriggerVariable::${JSON.stringify(param)}`,
            }));
        }
        return param !== null
            ? Object.assign(Object.assign({}, param), { errors }) : {
            name: '',
            description: '',
            errors,
            required: true,
            type: 'string',
        };
    });
}
//# sourceMappingURL=triggerInputs.js.map